<template>
  <!--  -->
  <div class="container-reports" style="height: 100%">
    <div class="options-download row mb-2 col-md-12 justify-content-center p-0">
      <b-button
        id="download-csv"
        pill
        size="sm"
        variant="info"
        class="m-1 align-items-center"
        @click="downloadCSV"
      >
        <csv-icon style="font-size: 1.1em; vertical-align: -3%" />
        Download CSV
      </b-button>
      <b-button
        id="download-xlsx"
        @click="downloadXLSX"
        pill
        size="sm"
        variant="info "
        class="m-1 align-items-center"
      >
        <excel-icon style="font-size: 1.1em; vertical-align: -3%" />
        Download XLSX
      </b-button>
      <b-button
        id="download-pdf"
        @click="downloadPDF"
        pill
        size="sm"
        variant="info align-items-center"
        class="m-1"
      >
        <pdf-icon style="font-size: 1.1em; vertical-align: -3%" />
        Download PDF
      </b-button>
    </div>
    <div ref="table"></div>
  </div>
</template>

<script>
import moment from "moment";
import Tabulator from "tabulator-tables";

export default {
  name: "tabulator",
  props: {
    reportTitle: {
      type: String,
      required: false,
      default: '',
    },
    data: {
      type: Array,
      required: false,
      default: [],
    },
    columns: {
      type: Array,
      required: false,
      default: [],
    },
  },
  data() {
    return {
      tabulator: null, //variable to hold your table
      tableData: [], //data for table to display
    };
  },
  watch: {
    //update table if data changes
    data: {
      handler(newData) {
        this.tabulator.replaceData(newData);
      },
      deep: true,
    },
  },
  computed: {
    fileTitle() {
      if(!this.reportTitle) {
        return 'data';
      }

      const baseTitle = this.reportTitle.split(" ").join("_").toLowerCase();
      const dateFormatted = moment().format("DD-MM-YYYY");

      return `${baseTitle}_${dateFormatted}`.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }
  },
  mounted() {
    //instantiate Tabulator when element is mounted
    this.tabulator = new Tabulator(this.$refs.table, {
      data: this.data,
      // height:"95%",
      // virtualDomBuffer: 300,
      // resizableColumns: true,
      layout: "fitColumns",
      // initialSort:[
      //     {column:"c-PERÍODO", dir:"asc"}, //sort by this first
      // ],
      // autoColumns:true,
      columns: this.columns,
    });
  },
  methods: {
    downloadXLSX() {
      this.tabulator.download("xlsx", `${this.fileTitle}.xlsx`, { sheetName: "Relatório" });
    },
    downloadCSV() {
      this.tabulator.download("csv", `${this.fileTitle}.csv`);
    },
    downloadPDF() {
      this.tabulator.download("pdf", `${this.fileTitle}.pdf`, {
        documentProcessing: function (workbook) {
          //workbook - sheetJS workbook object
          //set some properties on the workbook file
          workbook.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            CreatedDate: new Date(2017, 12, 19),
          };
          return workbook;
        },
      });
    },
  },
};
</script>

<style scoped>
.container-reports >>> .tabulator {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  border: none;

}

.container-reports >>> .tabulator .tabulator-header {
  font-weight: normal;
  border-bottom: 1px solid;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.54);
}

.container-reports >>> .tabulator .tabulator-header .tabulator-col {
  height: 38px;
  background-color: #f7f7f7;
  padding: 0 6px;
  font-size: 13px;
  text-align: center;
  font-weight: 600;
}

.container-reports >>> .tabulator .tabulator-col .tabulator-sortable {
  height: 62px !important;
}

.container-reports >>> .tabulator-row {
  border-bottom: 1px solid;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  min-height: 48px;
  vertical-align: middle;
}

.container-reports >>> .tabulator-row .tabulator-cell {
  padding: 16px 7px;
  vertical-align: middle;
}

.container-reports >>> .tabulator-row .tabulator-cell:first-of-type,
.container-reports >>> .tabulator .tabulator-header .tabulator-col:first-of-type {
  padding-left: 24px;
}

.container-reports >>> .tabulator-row.tabulator-row-even {
  background-color: #fcfcfc;
}

@media screen and (max-width: 1400px) {
  .container-reports >>> .tabulator {
    height: 85%;
  }
}

@media screen and (min-width: 1400px) {
  .container-reports >>> .tabulator {
    height: fit-content;
    max-height: 88%;
  }
}
</style>
